import { OFFICES } from 'constants/permissionConstants';
import React, { Dispatch } from 'react';
import { Dropdown, Menu, Tag } from 'antd';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { ColumnsType } from 'antd/lib/table';
import { OfficeType } from 'services/office';
import { getColumnHtml } from 'helpers/reactutils';
import { ChangeStatusLinkWithPermission, EditLinkWithPermission } from './withPermissionComponents';

type OfficeTableColumnsProps = {
  menuPermission: boolean;
  editPermission: boolean;
  changeStatusPermission: boolean;
  setEditPermission: Dispatch<boolean>;
  setChangeStatusPermission: Dispatch<boolean>;
  openUpdateOfficeStatusModal: (id: string, firstName: string, status: boolean) => void;
};

const OfficeTableColumns = (props: OfficeTableColumnsProps): ColumnsType<OfficeType> => {
  const {
    menuPermission,
    editPermission,
    setEditPermission,
    changeStatusPermission,
    setChangeStatusPermission,
    openUpdateOfficeStatusModal,
  } = props;

  return [
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'name', 'Office Name'),
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      width: '20%',
    },
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'phoneNumber', 'Phone'),
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      sorter: true,
      width: '20%',
    },
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'city', 'City/Town'),
      dataIndex: 'city',
      key: 'city',
      sorter: true,
      width: '15%',
    },
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'state', 'State'),
      dataIndex: 'state',
      sorter: true,
      key: 'state',
      width: '15%',
    },
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'isActive', 'Status'),
      dataIndex: 'isActive',
      key: 'isActive',
      sorter: true,
      render: (tag: React.Key | null | undefined) => {
        const color = tag ? 'green' : 'volcano';
        return (
          <Tag color={color} key={tag}>
            {tag ? 'Active' : 'Inactive'}
          </Tag>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (text: string, record: OfficeType) => (
        <Dropdown
          disabled={!menuPermission}
          overlay={
            <Menu key={`action-menu-${record.id}`} className="actionDropDown">
              <Menu.Item key={`edit-${record.id}`}>
                <EditLinkWithPermission
                  disabled={!editPermission}
                  record={record}
                  text={text}
                  componentPermissions={[OFFICES.EDIT]}
                  setPermission={setEditPermission}
                />
              </Menu.Item>
              <ChangeStatusLinkWithPermission
                disabled={!changeStatusPermission}
                record={record}
                text={text}
                openUpdateOfficeStatusModal={openUpdateOfficeStatusModal}
                componentPermissions={[OFFICES.ACTIVATE]}
                setPermission={setChangeStatusPermission}
              />
            </Menu>
          }>
          <div className="icon-set">
            <BiDotsVerticalRounded size={24} />
          </div>
        </Dropdown>
      ),
    },
  ];
};

export default OfficeTableColumns;
